import React, { useEffect } from "react";
import "bulma/css/bulma.css";
import "../../styles/css/App.css";
import munic from "../../assets/images/ayacucho/lg.png";
import Axios from "axios";
import sha256 from "js-sha256";
import auth from "./Auth.js";
import { Access } from "../../auth/Access.js";
import redirect from "../../auth/Redirection.js";
import * as Constants from "../../consts/Constants.js";

export default function Login({ history }) {
  const [data, setData] = React.useState({
    userName: "",
    password: "",
  });

  const handleSubmit = (e) => {
    var credentials = { email: data.userName, password: sha256(data.password) };

    var jsonData = JSON.stringify(credentials);
    Axios.post(Constants.FINAL_URL_AUTH, jsonData, {
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        Axios.defaults.headers.common["Authorization"] =
          "Bearer " + response.data.token;
        auth.login(
          credentials,
          response.data.token,
          response.data.additionalRoles,
          response.data.userId,
          response.data.role
        );

        //TODO puedo sacar esto de sesion y asignarlo en auth?
        localStorage.setItem("auth", JSON.stringify(auth));
        let access = new Access();
        if (access.canAccess()) {
          history.push(redirect.getIndexByRoles(auth.additionalRoles));
        }
      })
      .catch(function () {});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("auth"));
    if (user != null && user.authenticated) {
      //history.goBack();
      //		history.push("/src/Admin");
    }
  });

  return (
    <div className="App">
      <div className="notification">
        <p className="title is-2">APS - Ayacucho Plataforma de Servicios</p>
        <div className="Padd">
          <figure>
            <img src={munic} alt="Muncipalidad Ayacucho" />
          </figure>
        </div>
        <div className="Columns">
          <div className="Column"></div>
          <div className="Column">
            <div className="container">
              <div className="field">
                <p className="control has-icons-left has-icons-right">
                  <input
                    className="input 'Width=50px;'"
                    type="email"
                    name="userName"
                    onChange={handleChange}
                    placeholder="Email"
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-envelope"></i>
                  </span>
                  <span className="icon is-small is-right">
                    <i className="fas fa-check"></i>
                  </span>
                </p>
              </div>
              <div className="field">
                <p className="control has-icons-left">
                  <input
                    className="input"
                    type="password"
                    name="password"
                    onChange={handleChange}
                    placeholder="Password"
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-lock"></i>
                  </span>
                </p>
              </div>
              <button className="button is-success" onClick={handleSubmit}>
                Login
              </button>
            </div>
          </div>
          <div className="Column"></div>
        </div>
      </div>
      <footer className="footer">
        <p>
          <strong>APS - Ayacucho Plataforma de Servicios</strong> desarrollada
          por <a href="http://www.intia.exa.unicen.edu.ar/">INTIA</a>-
          <a href="http://www.isistan.unicen.edu.ar/">ISISTAN</a> en conjunto
          con la{" "}
          <a href="https://www.ayacucho.gob.ar/?q=content/ayacucho-plataforma-servicios-aps">
            Municipalidad de Ayacucho
          </a>
          .
        </p>
      </footer>
    </div>
  );
}
